// extracted by mini-css-extract-plugin
export var border = "_1v-8";
export var brand = "_1v-t";
export var button = "_1v-l";
export var center = "_1v-a";
export var centered = "_1v-6";
export var closeButton = "_1v-c";
export var disabledWrapper = "_1v-m";
export var error = "_1v-p";
export var extraLarge = "_1v-4";
export var extraSmall = "_1v-1";
export var fill = "_1v-i";
export var footer = "_1v-h";
export var footerAction = "_1v-j";
export var footerButtons = "_1v-k";
export var header = "_1v-7";
export var headerWithClose = "_1v-d";
export var icon = "_1v-o";
export var info = "_1v-s";
export var inline = "_1v-9";
export var large = "_1v-3";
export var main = "_1v-e";
export var modal = "_1v-0";
export var nearFull = "_1v-5";
export var neutral = "_1v-u";
export var noPadding = "_1v-g";
export var none = "_1v-v";
export var scrollable = "_1v-f";
export var small = "_1v-2";
export var success = "_1v-r";
export var tight = "_1v-n";
export var titleIcon = "_1v-b";
export var warn = "_1v-q";